export default __webpack_public_path__ + "static/media/badge-premium.90f18dd1.svg";